module.exports = __webpack_public_path__ + "img/27-ninja.b1c1e73d.svg";